<app-add-form
  data-testid="purchase-request-view-form"
  [title]="'purchase_request.view.title' | translate"
  [formFields]="formFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [editMode]="false"
  [viewMode]="true"
  [initialData]="currentFormData"
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>

<!-- Toast Messages -->
<p-toast data-testid="purchase-request-view-toast"></p-toast>
